import React from "react";
import DashboardLayout from "layouts/DashboardLayout";
import EmptyScreen from "./EmptyScreen";
import useDocumentTitle from "utils/useDocumentTitle";

const MutualFundOrders = () => {
  useDocumentTitle("Orders");

  return (
    <DashboardLayout title="Orders">
      <EmptyScreen />
    </DashboardLayout>
  );
};

export default MutualFundOrders;
